import { Box, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import React from "react";
import {
  HiOutlineArrowPath,
  HiOutlineExclamationTriangle,
  HiOutlinePlay,
  HiOutlineTrash,
} from "react-icons/hi2";

import { Button, IconButton } from "../../../../components";
import { FileIcon } from "./FileIcon";
import { disabledButtonStyles, enabledButtonStyles } from "./styles";

type ErrorContentProps = {
  fileName: string;
  fileType: string;
  metaText?: string;
  canRetry?: boolean;
  readOnly?: boolean;
  onRetry?: () => void;
  onRemove?: () => void;
};

export const ErrorContent: React.FC<ErrorContentProps> = ({
  fileName,
  fileType,
  metaText,
  canRetry,
  readOnly,
  onRetry,
  onRemove,
}) => (
  <HStack justify="space-between" spacing="24px" align="center" width="100%">
    <HStack spacing="16px" align="center" flex="1">
      <FileIcon fileType={fileType} />
      <VStack align="start" spacing="4px" flex="1">
        <Text
          fontSize="14px"
          fontWeight="semibold"
          color="gray.900"
          lineHeight="20px"
          maxW="100%"
        >
          {fileName}
          {metaText && (
            <Text as="span" fontWeight="normal" color="gray.600">
              {" "}
              • {metaText}
            </Text>
          )}
        </Text>
        <VStack align="start" spacing="4px" width="100%">
          <Box
            width="400px"
            maxW="100%"
            height="8px"
            borderRadius="full"
            bg="gray.100"
            position="relative"
            overflow="hidden"
          >
            <Box height="100%" width="30%" borderRadius="full" bg="red.500" />
          </Box>
          {!readOnly ? (
            <HStack
              spacing="8px"
              py="4px"
              width="400px"
              maxW="100%"
              justify="space-between"
              align="center"
            >
              <HStack spacing="8px">
                <Icon
                  as={HiOutlineExclamationTriangle}
                  boxSize="24px"
                  color="red.500"
                />
                <Text fontSize="14px" color="red.600" lineHeight="20px">
                  Error
                </Text>
              </HStack>
              <Button
                size="xs"
                height="24px"
                px="8px"
                fontSize="11.67px"
                lineHeight="16px"
                variant="outline"
                border="1px solid"
                borderColor="blue.600"
                color="blue.600"
                leftIcon={<HiOutlineArrowPath size={16} />}
                _hover={{ bg: "white" }}
                _active={{ bg: "white" }}
                onClick={onRetry}
              >
                Retry
              </Button>
            </HStack>
          ) : (
            <HStack spacing="8px" py="4px">
              <Icon
                as={HiOutlineExclamationTriangle}
                boxSize="24px"
                color="red.500"
              />
              <Text fontSize="14px" color="red.600" lineHeight="20px">
                Error
              </Text>
            </HStack>
          )}
        </VStack>
      </VStack>
    </HStack>
    {!readOnly && (
      <VStack spacing="8px" align="center" justify="center" pr={4}>
        <IconButton
          aria-label="Play"
          icon={<HiOutlinePlay size={16} />}
          {...disabledButtonStyles}
          size="xs"
          borderRadius="4px"
          minW="24px"
          width="24px"
          height="24px"
          p="4px"
          isDisabled
        />
        <IconButton
          aria-label="Remove"
          icon={<HiOutlineTrash size={16} />}
          {...enabledButtonStyles}
          size="xs"
          borderRadius="4px"
          minW="24px"
          width="24px"
          height="24px"
          p="4px"
          onClick={onRemove}
        />
      </VStack>
    )}
  </HStack>
);
